export default __webpack_public_path__ + "static/grief_horiz_rev_aug2023-dcd7a82b3ac5cdf4215ee2bdef012273.jpg";